import { render, staticRenderFns } from "./TableInvCategories.vue?vue&type=template&id=6f0f5c18"
import script from "./TableInvCategories.vue?vue&type=script&lang=js"
export * from "./TableInvCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports